// extracted by mini-css-extract-plugin
export default {"component":"_6pUvDCo4","checkbox":"HVrwjr0q","label":"PTuz9kKo"};